"use client";

import { ElementType, ReactNode } from "react";
import { clsx } from "clsx";

export type FontType =
  | "web_menu_item"
  | "web_body"
  | "h1_title"
  | "h2_title"
  | "h3_title"
  | "menu_item"
  | "info_text"
  | "paragraph"
  | "heading_3"
  | "sub_title"
  | "application_body"
  | "heading_5"
  | "heading_5_normal"
  | "small_paragraph"
  | "button_label";

interface TextProps {
  as?: ElementType;
  children?: ReactNode;
  fontType?: FontType;
  className?: string;
  htmlFor?: string;
}

const fontClasses: Record<FontType, string> = {
  web_menu_item: "text-web_menu_item font-medium",
  web_body: "text-web_body font-regular",
  h1_title: "text-h1_title font-bold",
  h2_title: "text-h2_title font-bold",
  h3_title: "text-h3_title font-semibold",
  menu_item: "text-menu_item font-regular",
  info_text: "text-info_text font-regular",
  paragraph: "text-paragraph font-regular",
  heading_3: "text-heading_3 font-semibold",
  sub_title: "text-sub_title font-semibold",
  application_body: "text-application_body font-regular",
  heading_5: "text-heading_5 font-semibold",
  heading_5_normal: "text-heading_5_normal font-regular",
  small_paragraph: "text-small_paragraph font-medium",
  button_label: "text-button_label font-medium",
};

const Text = ({ fontType = "paragraph", as: Component = "span", children, className, ...rest }: TextProps) => {
  return (
    <Component className={clsx(fontClasses[fontType], className)} {...rest}>
      {children}
    </Component>
  );
};

export default Text;
